/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
  .controller('VideoBlockFormController', [
    'tempId',
    '$',
    '$compile',
    '$scope',
    'Restangular',
    'BulbErrorService',
    'SerialSaveService',
    'UnitStateStore',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    VideoBlockFormController,
  ]);

/**
 * Controller for the form used when creating video block via a URL such as YouTube or Vimeo.
 */
function VideoBlockFormController(
  tempId,
  $,
  $compile,
  $scope,
  Restangular,
  BulbErrorService,
  SerialSaveService,
  UnitStateStore,
) {
  this.url = null;
  this.tempId = tempId;

  // Normally, you could access a child form from the scope, but due to transcoding scope issues in angular, the form
  // is not being attached to the modal scope.  So, the workaround is to submit the form from inside
  // the template, as it has access to the 'default' scope to which the form is attached.
  // It looks like this is just how transclusion works, and it will not be fixed:
  // https://github.com/angular/angular.js/issues/5489
  this.submit = function submit(embedForm) {
    const embedBlockDTO = {
      url: this.url,
    };
    // TODO CLEAN : do we have to use $scope in all the places here?  can we get to it via this, or if not, should
    // we create a local reference?
    SerialSaveService.save({
      preventRetry: true,
      save: () => Restangular.one('units', $scope.contentEditorCtrl.page.unit.id)
        .customPOST(embedBlockDTO, 'embedblock')
        .then((response) => {
          $scope.contentEditorCtrl.page.unit.contentBlocks[response.contentBlock.id] = response.contentBlock;

          // update content with new content block information
          // find placeholder, and replace with content block:
          const contentBlockElement = $(`#${tempId}`);
          // TODO CLEAN - use a template rather than embedded string.
          contentBlockElement.replaceWith($compile(`<content-block id="${response.contentBlock.id
          }" contenteditable="false"></content-block>`)($scope));

          // Update share status to reflect that the page has been edited:
          const ShareTransition = UnitStateStore.getShareTransitionEnum();
          UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

          // TODO CLEAN : Is this necessary, or do we call it as necessary from within media-extension?
          $scope.contentEditorCtrl.editor.trigger(
            'editableInput',
            null,
            $scope.contentEditorCtrl.editor.elements[0],
          );
        }),
    }).catch((error) => {
      if (error.data.errorMap) {
        // allow the form controller to handle field validation errors:
        embedForm.handleRemoteErrors(error);
      } else {
        // DO LATER : should we have a Restangular interceptor show the error dialog, or is that too heavy-handed?
        // What if it would be inappropriate?   Perhaps some sort of preventDefault mechanism where the dialog is
        // shown only if it isn't prevented?
        BulbErrorService.showError(null, error);
      }
    });
  };
}
